import React from "react";
import { NavLink } from "react-router-dom";
import { Button } from "reactstrap";
export default function InformationPopup({ closePopup, message }) {
  return (
    <div className={`success_bg`}>
      <div className="success_content" style={{ maxWidth: "450px" }}>
        <NavLink to={""} onClick={() => closePopup()}>
          <img src="/assets/images/cross.svg" className="crossicon" alt="" />
        </NavLink>

        <img src="/assets/images/verify.svg" className="verify_img" alt="" />

        <div className="row">
          <div className="justify-content-center text-center">
            <h2>{message}</h2>
          </div>
        </div>
        <div className="row mt-3">
          <div className="justify-content-center text-center">
            <Button
              color="create_variations mb-3 ms-3"
              onClick={() => {
                closePopup();
              }}
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
